class ContactForm extends HTMLElement {
    constructor() {
      super();
    
      this.initEventListener();
      this.uploadFile();
    }

    initEventListener() {

      document.getElementById('contact-motif').addEventListener('change', function() {
        var subject = this.value;
        var email = document.querySelector('[value="' + subject + '"]').getAttribute('data-email');
        document.getElementById('mailReceipt').value = email;
      });

      /*document.querySelector("").addEventListener('submit', function(event) {
        event.preventDefault();

        const data = new FormData(event.target);
    
    

        var url = "https://ddr16m9k8j.execute-api.eu-west-3.amazonaws.com/dev/contact";

        var imagefile = document.querySelector('#ContactForm-file');
        data.append("contact[file]", imagefile.files[0]);     
        console.log(imagefile.files[0]);

        const value = Object.fromEntries(data.entries());
        console.log({ value });

        fetch(url, {
          method: 'post',
          headers: {'Content-Type': 'application/octet-stream'},
          body: value
        })
        .then((response) => {
            console.dir(response);
            return response.text();
        })
        .then((state) => {
           console.log(state);
        }).catch((error) => {
          console.log(error);
        });

      });
      */
    }

      convertFileToBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          // Typescript users: use following line
          // reader.onload = () => resolve(reader.result as string);
          reader.onerror = reject;
        });
      }

      startProgress() {
        var index = 0;
        document.getElementById('fileProgress').removeAttribute('hidden');
        this.progressInterval = setInterval(function() {
          if (index < 90) {
            document.getElementById('fileProgress').value = index;
            index += 1; 
          }
        }, 100);
      }
      
      endProgress(url) {
        clearInterval(this.progressInterval);
        document.getElementById('fileProgress').value = 100;
        setTimeout(function() {
          document.getElementById('fileProgress').setAttribute('hidden', 'hidden');
          document.querySelector('.contact__button button').removeAttribute('disabled');
        }, 1000);
        document.getElementById('fileFormValue').value = url;
      }


      uploadFile() {
        var that = this;
        document.getElementById("ContactForm-file").addEventListener('change', async function(e) {
          var file_name_splitted = this.value.split("\\");
          var file_name = file_name_splitted[file_name_splitted.length - 1];
  
          var data = new FormData()
  
          document.querySelector('.file-name').innerHTML = file_name;
          var input = document.getElementById("ContactForm-file");
  
          var fileb64 = await that.convertFileToBase64(input.files[0])
          data.append('file', fileb64)
          data.append('file_name', file_name);
  
          document.querySelector('.contact__button button').setAttribute('disabled', 'disabled');
  
          that.startProgress();
  
          fetch('https://u1rx391lx3.execute-api.eu-west-3.amazonaws.com/prod/upload?format=' + file_name, {
            method: 'POST',
            body: data,
          }).then((response) => {
            console.dir(response);
            return response.json();
          })
          .then((state) => {
            console.log(state);
            that.endProgress(state.result);
          }).catch((error) => {
  
          });
        });
        
      }

  
  }
  
  customElements.define('contact-form', ContactForm);
  